import { useLazyQuery, useMutation, useQuery } from '@apollo/client';
import {
  AppContext,
  ContentDeciderContainer,
  EventEmitter,
  Generator,
  getTranslatedText,
  getUnifiedConditions,
  isAuthorised,
  NoData,
  SkeletonTableLoading,
  TableContainer,
  updateConditions,
  useStateCallback,
  SuperTable,
  getTableRowCount,
  saveTableRowCount,
  getCurrentUserHook,
  getAllColumnWidth,
  saveColumnWidth,
  ALL_TABLES,
  getDefaultRowCount,
  toast,
  getDifference,
  getDateOperators,
  useProduct,
  COMMON_CONSTANTS,
  generateString,
  useUserMSPCheckHook
} from '@nile/components';
import { DEFAULT_TICKET_CONDITION } from '@nile/components/src/Pebbles/AdvancedTicketFilter';
import {
  AccountClient,
  GET_PERSONALIZATION_BY_NAME,
  SAVE_PERSONALIZATION,
  TicketClient,
  useCachedQuery,
  UPDATE_TICKET,
  useCustomTransition
} from '@nile/graphql';
import envConfig from '@nile/home/src/Config/env';
import { defaultColumns } from '@nile/mangifera/src/Constants/Tickets';
import { TicketContext } from '@nile/mangifera/src/Contexts';
import {
  getAccessor,
  getDependantField,
  getParentField,
  getTicketFields,
  getType,
  isClearable,
  isDependantField,
  isEditable,
  isFilterable,
  isSortable,
  getColumnWidth,
  getWidthFromPersonalization
} from '@nile/mangifera/src/Pebbles/TicketContainer';
import {
  checkDynamicQuery,
  fetchValues,
  generateOptions,
  getAllowedProperties,
  getAsyncOptions,
  getDefaultValue,
  getDynamicQuery,
  getKeyName,
  getMethodName
} from '@nile/mangifera/src/Pebbles/TicketToolbar';
import gql from 'graphql-tag';
import { cloneDeep, isEmpty, isEqual, merge, omit } from 'lodash';
import React, {
  useCallback,
  useContext,
  useEffect,
  useState,
  useTransition
} from 'react';
import { injectIntl } from 'react-intl';
import { withRouter } from 'react-router-dom';
import styled from 'styled-components';
import {
  defaultPersonalization,
  getAllTicketFields,
  TICKET_SCHEMA
} from '../../Constants/Tickets';
import { useFlags } from 'launchdarkly-react-client-sdk';
import TicketTable from '@nile/mangifera/src/Components/Ticket/TicketTable';
import {
  DateTimeCell,
  SubjectCell,
  LinkCell,
  NameCell,
  PriorityCell,
  StepCell,
  TimerCell,
  ProgressCell,
  CustomTimeCell,
  CustomTextCell,
  CustomSecureTextCell,
  CustomRadioCell,
  CustomCheckboxCell,
  CustomSelectCell,
  HoursMinutesCell
} from '@nile/mangifera/src/Components/Ticket';
// import InlineEditTextCell from '@nile/mangifera/src/Components/Ticket/InlineEditTextCell';
import InlineEditTextCellV2 from '@nile/mangifera/src/Components/Ticket/InlineEditTextCellV2';
import InlineStatusCell from '@nile/mangifera/src/Components/Ticket/InlineStatusCell';
// import InlineEditDualCell from '@nile/mangifera/src/Components/Ticket/InlineEditDualCell';
import InlineEditDualCellV2 from '@nile/mangifera/src/Components/Ticket/InlineEditDualCellV2';
import ClosureModal from '../../Components/Ticket/ClosureModal';
import NewInlineStatusCell from '@nile/mangifera/src/Components/Ticket/NewInlineStatusCell';
import { getWindowId } from '@nile/components/src/Utils/helpers';

let querySubscription = null;

function TicketContainer(props) {
  const { ticketViewMeta, intl } = props;
  const flags = useFlags();
  const dynamicPaginationFlag = flags?.dynamicPaginationTickets;
  const context = useContext(TicketContext);
  const isMSPProduct = useProduct(COMMON_CONSTANTS.MSP);
  const contextByRef = React.useRef(0);
  contextByRef.current = context;
  const appContext = useContext(AppContext);
  const [data, setData] = useState([]);
  const dataByRef = React.useRef([]);
  dataByRef.current = data;
  const [listInfo, setListInfo] = useStateCallback({});
  const [closureSaveLoading, setClosureSaveLoading] = useState(false);
  const listInfoByRef = React.useRef(1);
  listInfoByRef.current = listInfo;
  const [columnGroup, setColumnGroup] = useState([
    { Header: 'Name', header: 'Name', columns: [] }
  ]);
  const columnGroupByRef = React.useRef(null);
  columnGroupByRef.current = columnGroup;
  const tableName = ALL_TABLES.tickets;
  const ROW_COUNT = dynamicPaginationFlag
    ? getTableRowCount(tableName)
    : getDefaultRowCount(tableName);
  const [rowCount, setRowCount] = useState(ROW_COUNT);
  const columnWidthObject = getAllColumnWidth(tableName);
  const [isPending, startTransition] = useTransition();
  const isMSP = useUserMSPCheckHook();

  const [skipPageReset, setSkipPageReset] = useState(false);
  const [editCellId, setEditCellId] = useState(null);
  const setEditCell = (cellId) => {
    setEditCellId(cellId || null);
  };
  const { ticketViews } = props;

  const [activeView, setActiveView] = useState(
    ticketViews.find((item) => {
      return item.id === props.match.params.id;
    })
  );
  const activeViewByRef = React.useRef(2);
  activeViewByRef.current = activeView;

  const viewId = activeViewByRef.current.id;

  const sortFromGlobalState =
    context?.globalState?.[tableName]?.sortData?.[viewId];

  const [options, setOptions] = useState({
    page: context?.activeTab?.state?.pageNumber || 1,
    sort: context?.activeTab?.state?.sort || [
      {
        attribute: 'createdTime',
        order: 'DESC'
      }
    ],
    condition: context?.activeTab?.state?.condition || null
  });
  const user = getCurrentUserHook();
  const roleFeatures = user?.role?.roleFeatureList || [];
  const isTicketEditAuthorised = isAuthorised(roleFeatures, 'tickets.edit');
  const [closureModalactive, setClosureModalActive] = useState(false);
  const [showLiveUpdate, setShowLiveUpdate] = useState(false);
  const [isLiveUpdating, setIsLiveUpdating] = useState(false);
  const liveUpdateTicketListRef = React.useRef([]);
  const [errorsOnClosure, setErrorsOnClosure] = useState(null);
  const errorsOnClosureByRef = React.useRef(null);
  errorsOnClosureByRef.current = errorsOnClosure;

  const { sortAttributes } = ticketViewMeta;

  const { match, allEntities } = props;
  const ticketAttributes = allEntities.find((item) => {
    return item.name === 'Ticket';
  }).attributes;

  if (activeView) {
    // options.condition =  activeView.viewCondition
    options.view = { id: activeView.id };
  }

  defaultColumns.subject.actions = {
    onClick: context.openTicket
  };

  // console.log(allEntities, 'ash:: allEntities');

  const defaultColumn = React.useMemo(() => {
    return {
      minWidth: 30,
      maxWidth: 500,
      width: 150,
      Priority: PriorityCell,
      HTML: SubjectCell,
      Text: InlineEditTextCellV2,
      Timer: TimerCell,
      Status: NewInlineStatusCell,
      DateTime: DateTimeCell,
      Dependant: InlineEditTextCellV2,
      Dual: InlineEditDualCellV2,
      Progress: ProgressCell,
      CustomTime: CustomTimeCell,
      CustomText: CustomTextCell,
      CustomRadio: CustomRadioCell,
      CustomCheckbox: CustomCheckboxCell,
      CustomSelect: CustomSelectCell,
      HoursMinutes: HoursMinutesCell,
      SecureText: CustomSecureTextCell
      // Priority: <div>Hello</div>,
      // HTML: <div>Hello</div>,
      // Text: <div>Hello</div>,
      // Timer: <div>Hello</div>,
      // Status: <div>Hello</div>,
      // DateTime: <div>Hello</div>,
      // Dependant: <div>Hello</div>
      // Dual: <div>Hello</div>,
      // Progress: <div>Hello</div>,
      // CustomTime: <div>Hello</div>,
      // CustomText: <div>Hello</div>,
      // CustomRadio: <div>Hello</div>,
      // CustomCheckbox: <div>Hello</div>,
      // CustomSelect: <div>Hello</div>,
      // HoursMinutes: <div>Hello</div>,
      // SecureText: <div>Hello</div>
    };
  }, []);

  const [savePersonalization] = useMutation(SAVE_PERSONALIZATION, {
    client: AccountClient
  });

  const handleClickOutside = (e) => {
    // temp for class checking to avoid closing the dropdown
    if (
      (e.target.classList &&
        e.target.classList.contains('value_selector__option')) ||
      e.target.classList.contains('react-select-label') ||
      e?.target?.classList?.contains('select-option') ||
      e?.target?.classList?.contains('Superops-Badge--badgeIcon') || // For clicking on badge icon from status dropdown
      e?.target?.classList?.contains('Superops-Badge') // For clicking on badge from status dropdown
    ) {
      return;
    }
    setEditCell(null);
  };

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    if (!context.viewConditions) {
      context.setViewConditions(context?.activeTab?.state?.condition);
    }
    EventEmitter.subscribe('tabChange', updateTabState);
    EventEmitter.subscribe('refreshList', refreshList);
    EventEmitter.subscribe('switchTicketView', saveSortOrder);
    EventEmitter.subscribe('ticketClosureError', getClosureFields);
    setTimeout(() => {
      EventEmitter.dispatch('hideMonicaAi');
    }, 1000);

    return function cleanup() {
      EventEmitter.unsubscribe('tabChange');
      EventEmitter.unsubscribe('refreshList');
      EventEmitter.unsubscribe('switchTicketView');
      EventEmitter.unsubscribe('ticketClosureError');
      if (querySubscription) {
        querySubscription.unsubscribe();
      }
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  /**
   * On view switch reset the options state. Else it will be applied to next view
   */
  useEffect(() => {
    setOptions({
      page: context?.activeTab?.state?.pageNumber || 1,
      sort: context?.activeTab?.state?.sort || [
        {
          attribute: 'createdTime',
          order: 'DESC'
        }
      ],
      condition: context?.activeTab?.state?.condition || null
    });
    setListInfo({});
  }, [context?.activeTab?.state]);

  /**
   * Pass params for loading data during personalisation changes.
   */

  useEffect(() => {
    if (context.personalization) {
      fetchViewData(context.personalization, {
        page: listInfo?.page || options.page,
        pageSize: rowCount,
        sort:
          sortFromGlobalState || listInfoByRef?.current?.sort || options.sort,
        condition: context.viewConditions || options.condition
      });
    }
  }, [context.personalization]);

  useEffect(() => {
    if (context.personalization && !isEmpty(listInfo)) {
      fetchViewData(context.personalization, {
        page: 1,
        pageSize: rowCount,
        sort:
          sortFromGlobalState || listInfoByRef?.current?.sort || options.sort,
        condition: context.viewConditions
      });
    }
  }, [JSON.stringify(context.viewConditions)]);

  const refreshList = (callback) => {
    fetchViewData(
      contextByRef.current.personalization,
      {
        page: 1,
        pageSize: rowCount,
        condition: contextByRef.current.viewConditions,
        sort: sortFromGlobalState
          ? sortFromGlobalState
          : listInfoByRef?.current?.sort === null
          ? null
          : listInfoByRef?.current?.sort || options?.sort
      },
      callback
    );
  };

  const matchParamsByRef = React.useRef(null);
  matchParamsByRef.current = props.match.params;

  const updateTabState = (eventData) => {
    context.updateTabState(
      {
        condition: contextByRef.current.viewConditions,
        pageNumber: listInfoByRef.current.page,
        sort: listInfoByRef.current.sort
      },
      eventData
    );
    context.setPersonalization(''); // set personalisation as null on tab switch
    saveSortOrder(matchParamsByRef.current.id); // save current ticket view sort on tab switch
  };

  const getVariables = (pageOptions) => {
    const variables = {
      listInfo: {
        value: pageOptions
          ? { ...pageOptions, view: { id: activeView.id } }
          : options,
        type: 'ListInfoInput',
        required: true
      }
    };
    return variables;
  };

  const constructUnifiedConditions = (updatedCondition) => {
    const params = {
      conditions: contextByRef.current.viewConditions,
      defaultCondition: DEFAULT_TICKET_CONDITION,
      updatedCondition: updatedCondition
    };
    const complexCondition = getUnifiedConditions(params);
    context.setViewConditions(complexCondition);
  };

  const updateAllConditions = (condition, selectedField) => {
    updateConditions({
      condition,
      selectedField,
      viewConditions:
        contextByRef.current.viewConditions?.operands?.[0] || null,
      setConditions: constructUnifiedConditions
    });
  };

  const freezeCellCheck = (cellData) => {
    const rowData = cellData.row.original;
    if (cellData.column.Header === 'Status') return false;
    return rowData.client === null || (!isMSPProduct && rowData.site === null);
  };

  const isCheckBoxInactive = (rowData) => {
    switch (activeViewByRef?.current?.systemViewProperty) {
      case 'UNKNOWN_TICKET':
      case 'TRASH_TICKET':
        return false;
      default:
        return rowData.client === null;
    }
  };

  const [ticketListLoading, setTicketListLoading] = useState(true);

  const fetchViewData = async (personalization, pageOptions, callback) => {
    if (querySubscription) {
      querySubscription.unsubscribe();
    }
    setTicketListLoading(true);
    const personalizedColumns = personalization
      ? JSON.parse(personalization)
      : defaultPersonalization(isMSPProduct);
    const generator = new Generator({
      operation: 'getTicketList',
      variables: getVariables(pageOptions),
      fields: getTicketFields(personalizedColumns, isMSPProduct)
    });
    const queryString = generator.queryBuilder();
    querySubscription = TicketClient.watchQuery({
      query: gql`
        ${queryString.query}
      `,
      fetchPolicy: 'cache-and-network',
      variables: {
        listInfo: pageOptions
          ? {
              ...pageOptions,
              view: {
                id: activeViewByRef.current.id
              },
              condition:
                pageOptions.condition || context?.viewConditions || null
            }
          : {
              ...options,
              pageSize: rowCount,
              condition: context?.viewConditions || null,
              sort: listInfo.sort || sortFromGlobalState || options.sort || null
            }
      }
    }).subscribe((response) => {
      if (!response) {
        setTicketListLoading(true);
      }
      if (response) {
        const { data } = response;
        if (data) {
          setTicketListLoading(false);
        }

        if (data?.getTicketList) {
          setData(data?.getTicketList?.tickets);
          setListInfo(data?.getTicketList?.listInfo);
          if (callback) {
            if (!response?.loading) {
              callback();
            }
          }
        }
        const tabId = context?.activeTab?.id;
        const sortData = data?.getTicketList?.listInfo?.sort;
        const sortDataToSave = {
          [tableName]: {
            sortData: {
              [viewId]: sortData
            }
          }
        };
        context?.updateGlobalState(sortDataToSave, tabId);
      }
    });
    const cols = personalizedColumns;
    const roleFeatures = user?.role?.roleFeatureList || [];
    const isTicketEditAuthorised = isAuthorised(roleFeatures, 'tickets.edit');
    const allowedProperties = getAllowedProperties(props.allEntities, intl);
    const filteredCols = [];
    personalizedColumns.map((el) => {
      ticketAttributes.forEach((c) => {
        if (el.name === c.name) {
          filteredCols.push({
            ...el,
            nestedTo: c?.nestedTo,
            isDependent: c?.isDependent,
            nestedAttributes: c?.nestedAttributes,
            label: getTranslatedText(intl, c.label),
            filterType: c.filterType
          });
        }
      });
    });

    const columns = filteredCols.map((col, idx) => {
      return {
        Header: col.label,
        header: col.label,
        accessor: getAccessor(col),
        accessorKey: getAccessor(col),
        minSize: getColumnWidth(col.name).minWidth,
        size: getWidthFromPersonalization(col.name, columnWidthObject),
        type: getType(col),
        id: col.name,
        superIndex: idx,
        disableResizing: false,
        className: 'sticky',
        disableSortBy: !isSortable(col, sortAttributes),
        editable:
          context?.activeView?.id !== '9' &&
          isTicketEditAuthorised &&
          isEditable(col),
        // editable: false,
        clearable:
          context?.activeView?.id !== '9' &&
          isTicketEditAuthorised &&
          isClearable(col),
        disableFilters: !isFilterable(allowedProperties, col),
        shouldFreezeCell: freezeCellCheck,
        setEditCell: setEditCell,
        helpers: {
          getDefaultValue,
          getDynamicQuery,
          checkDynamicQuery,
          generateOptions,
          getMethodName,
          getKeyName,
          getDateOperators,
          getVariables,
          fetchValues,
          getAsyncOptions,
          updateConditions: updateAllConditions
        },
        actions: getActions(col),
        field: {
          ...col,
          parent: ticketAttributes?.find((attr) => attr?.name === col?.nestedTo)
        },
        meta: {
          ticketAttributes
        },
        parentField: isDependantField(col.name)
          ? {
              ...ticketAttributes.find(
                (el) => el.name === getParentField(col.name)
              ),
              label: getTranslatedText(
                intl,
                ticketAttributes.find(
                  (el) => el.name === getParentField(col.name)
                ).label
              )
            }
          : col,
        dependantField: isDependantField(col.name)
          ? col
          : ticketAttributes.find(
              (el) => el.name === getDependantField(col.name)
            ),
        isTrashView: context?.activeView?.id === '9'
      };
    });
    if (flags?.deferTableRendering && !flags?.ticketListviewPageRefresh) {
      startTransition(() => {
        setColumnGroup([{ Header: 'Name', header: 'Name', columns }]);
      });
    } else {
      setColumnGroup([{ Header: 'Name', header: 'Name', columns }]);
    }

    // setData(response?.data?.getTicketList?.tickets);
    // setListInfo(response?.data?.getTicketList?.listInfo);
  };

  const saveSortOrder = (ticketId) => {
    const sortState = {
      sort: listInfoByRef?.current?.sort || null
    };
    const personalisedData = {
      name: ticketId,
      category: 'TicketViewPersonalization',
      value: JSON.stringify(sortState),
      user: {
        firstName: user?.firstName,
        userId: user?.userId,
        email: user?.email,
        lastName: user?.lastName
      }
    };
    // if (!isEqual(sortState.sort, listInfoByRef.current.sort)) {
    AccountClient.mutate({
      mutation: SAVE_PERSONALIZATION,
      variables: personalisedData,
      input: personalisedData,
      update(cache, { data: newData }) {
        cache.writeQuery({
          query: GET_PERSONALIZATION_BY_NAME,
          data: {
            getPersonalizationByCategoryAndName: personalisedData
          },
          variables: {
            name: ticketId,
            category: 'TicketViewPersonalization',
            userId: user?.userId
          }
        });
      }
    });
    // savePersonalization({
    //   variables: personalisedData,
    //   input: personalisedData
    // });
    // }
  };

  const setColumnPersonalisation = (personalizationJSON) => {
    if (personalizationJSON) {
      context.setPersonalization(personalizationJSON);
    } else {
      context.setPersonalization(
        JSON.stringify(defaultPersonalization(isMSPProduct))
      );
    }
  };

  const [
    getColumnPersonalization,
    { data: personalizationDataFromQuery }
  ] = useLazyQuery(GET_PERSONALIZATION_BY_NAME, {
    fetchPolicy: 'cache-and-network',
    client: AccountClient,
    onError(err) {
      setTicketListLoading(false);
      console.log(err);
    }
  });

  useEffect(() => {
    // console.log(personalizationDataFromQuery);
    if (
      personalizationDataFromQuery?.hasOwnProperty(
        'getPersonalizationByCategoryAndName'
      )
    ) {
      const personalizationJSON =
        personalizationDataFromQuery?.getPersonalizationByCategoryAndName
          ?.value;
      setColumnPersonalisation(personalizationJSON);
    }
  }, [personalizationDataFromQuery]);

  /**
   * @description
   * Storing variable to pass when calling query function.
   * Giving default variables to useLazyQuery cause the query to
   * automatically execute if the value changes
   */

  const getColumnPersonalizationVariables = {
    variables: {
      userId: user.userId,
      category: 'TicketView',
      name: match.params.id
    }
  };

  const {
    loading: personalizationLoading,
    error: personalizationError,
    data: generalPersonalization
  } = useCachedQuery(GET_PERSONALIZATION_BY_NAME, {
    variables: {
      userId: user.userId,
      category: 'TicketViewPersonalization',
      name: props.match.params.id
    },
    client: AccountClient,
    onError() {
      getColumnPersonalization(getColumnPersonalizationVariables);
    }
  });

  useEffect(() => {
    if (
      generalPersonalization?.hasOwnProperty(
        'getPersonalizationByCategoryAndName'
      )
    ) {
      const personalization =
        generalPersonalization?.getPersonalizationByCategoryAndName?.value;
      if (personalization) {
        const personalizationJSON = JSON.parse(personalization);
        setListInfo(
          {
            ...options,
            sort: personalizationJSON.sort
          },
          () => {
            if (personalizationJSON.columns) {
              setColumnPersonalisation(
                JSON.stringify(personalizationJSON.columns)
              );
            } else {
              getColumnPersonalization(getColumnPersonalizationVariables);
            }
          }
        );
      } else {
        getColumnPersonalization(getColumnPersonalizationVariables); // REMOVE else case when general personalization includes column personalization.
      }
    }
  }, [generalPersonalization]);

  const getRequiredVariables = (diff) => {
    const variables = {};
    for (const prop in diff) {
      variables[prop] = {
        value: diff[prop],
        type: TICKET_SCHEMA[prop],
        inputVariable: prop !== 'id',
        required: prop === 'id'
      };
    }
    return variables;
  };

  const getClosureFields = (errorFields) => {
    setClosureModalActive(true);
    setErrorsOnClosure({
      ticket: errorFields?.param.ticket,
      status: errorFields?.param?.status,
      fields: errorFields?.param?.fields
    });
  };

  const [updateTicket] = useMutation(UPDATE_TICKET, {
    client: TicketClient
  });

  const updateTicketOnClosure = (ticket, variables) => {
    setClosureSaveLoading(true);
    const ticketId = ticket?.ticketId;

    updateTicket({
      variables: {
        id: ticketId,
        ...variables
      }
    })
      .then((res) => {
        if (res?.data?.updateTicket) {
          setClosureModalActive(false);
          setErrorsOnClosure(null);
          setClosureSaveLoading(false);
          toast('success', 'app.toast.ticket.update.success');
          updateMyData(res?.data?.updateTicket, {
            id: ticketId,
            ...res?.data?.updateTicket,
            ...variables
          });
        } else {
          setClosureSaveLoading(false);
        }
      })
      .catch((err) => {
        setClosureSaveLoading(false);
      });
  };

  const save = (updatedProperties, ticket, oldData, callback) => {
    const diff = { ...updatedProperties };
    if (isEmpty(diff)) {
      callback && callback('success');
      return;
    }
    if (ticket.ticketId) {
      diff.id = ticket.ticketId;
    }
    if (diff.customFields) {
      const updatedDiff = getDifference(diff.customFields, ticket.customFields);
      diff.customFields = updatedDiff;
    }

    updateTicket({ variables: diff })
      .then((res) => {
        if (res?.data?.updateTicket) {
          updateMyData(res?.data?.updateTicket, {
            ...diff,
            customFields: res?.data?.updateTicket?.customFields
          });
          callback && callback('success');
          if (diff?.customFields) {
            toast('success', 'app.toast.ticket.update.success');
          }
        } else {
          callback && callback('error');
        }
      })
      .catch((err) => {
        callback && callback('error');
      });
  };

  const getActions = useCallback((col) => {
    switch (col.name) {
      case 'subject':
        return {
          onClick: context.openTicket,
          updateMyData,
          refreshTable: refreshList
        };

      default:
        return {
          save: save
        };
    }
  });

  // To check if we need to highlight the row
  const [isHighlighting, setIsHighLighting] = useState(false);

  const checkRowHighlight = (row) => {
    if (isHighlighting && liveUpdateTicketListRef.current?.length) {
      const ticketIdInRow = row?.original?.ticketId;
      return liveUpdateTicketListRef.current.find((el) => el === ticketIdInRow);
    }
  };

  // Function when live update is completed
  let timeoutId;
  const onLiveUpdateComplete = () => {
    if (timeoutId) {
      clearTimeout(timeoutId);
    }
    if (showLiveUpdate) {
      setIsLiveUpdating(false);
      setShowLiveUpdate(false);
      setIsHighLighting(true);
      timeoutId = setTimeout(() => {
        liveUpdateTicketListRef.current = [];
        setIsHighLighting(false);
      }, 2500);
    }
  };

  // Function to call when refresh button is clicked
  const onLiveUpdateRefresh = (personalisation, pageOptions) => {
    setIsLiveUpdating(true);
    const updatedPageOptions = {
      ...pageOptions,
      condition: contextByRef.current?.viewConditions || null
    };
    fetchViewData(
      personalisation,
      updatedPageOptions,
      onLiveUpdateComplete
    ).then((res) => {
      console.log;
    });
  };

  // Function called when there is an event from WS in superTable
  const onWebSocketEventMessage = (eventData) => {
    const payload = eventData?.payload;
    const type = payload?.type;
    const entity = payload?.page?.entity;
    const pageType = payload?.page?.type;
    const event = payload?.event;
    const updateTicketId = payload?.data?.record?.current?.ticketId;
    const wsWindowId = payload?.page?.windowId;
    if (
      type === 'SERVER_EVENT' &&
      pageType === 'LIST' &&
      entity === 'TicketView' &&
      wsWindowId === windowId
    ) {
      if (
        event === 'CREATE' ||
        event === 'ADD_TO_LIST' ||
        event === 'REMOVE_FROM_LIST' ||
        event === 'TRASH' ||
        event === 'UPDATE'
      ) {
        liveUpdateTicketListRef.current.push(updateTicketId);
        setShowLiveUpdate(true);
      }
      if (event === 'DELETE' && viewId === '9') {
        setShowLiveUpdate(true);
        liveUpdateTicketListRef.current.push(updateTicketId);
      }
    }
  };

  useEffect(() => {
    const newActiveView = ticketViews.find((item) => {
      return item.id === props.match.params.id;
    });
    context.setPreviousView(context.activeView);
    context.setActiveView(newActiveView);
    setActiveView(newActiveView);
    if (activeView.id !== newActiveView.id) {
      setColumnGroup([{ Header: 'Name', header: 'Name', columns: [] }]);
    }
  }, [props.match.params.id]);

  // useEffect(() => {
  //   if (customLoading) {
  //     setTicketListLoading(true);
  //   }
  // }, [customLoading]);

  /** **********************************************************
  /***  BUG. NEED TO FIND THE REASON FOR UNUSUAL STATE UPDATE ***
          No need to send oldData as argument.
          Should be available in the sate itself as `data`
 /*********************************************************** */

  const updateMyData = useCallback((newTicketData, diff) => {
    const newTableData = cloneDeep(dataByRef.current);
    const updatedTicketIndex = dataByRef.current.findIndex(
      (el) => el.ticketId === newTicketData.ticketId
    );
    const updatedDiff = omit(diff, ['id']);
    if (diff.client && newTicketData?.site) {
      updatedDiff.site = newTicketData.site;
    }
    if (diff.customFields && newTicketData?.customFields) {
      updatedDiff.customFields = newTicketData.customFields;
    }
    newTableData[updatedTicketIndex] = merge(
      newTableData[updatedTicketIndex],
      updatedDiff
    );
    setData(newTableData);
  }, []);
  // console.log({ personalizationLoading, ticketListLoading });
  // if (columnGroup[0]?.columns.length < 0) return <div>Loading</div>;

  // if we give table conditions first, operands will be array of aconditions. simple filters.
  // else if we give advanced, then it will be array of filter groups.
  const tableConditionOperands = context.viewConditions?.operands?.[0]
    ?.joinOperator
    ? context.viewConditions.operands[0]?.operands
    : context?.viewConditions?.operands?.filter((el) => el.attribute) || [];
  const tableConditionsForFilter = tableConditionOperands.length
    ? {
        joinOperator: 'AND',
        operands: tableConditionOperands
      }
    : null;

  // Payload we need to send to Supertable for WS
  const windowId = getWindowId();

  const DEFAULT_WS_PAYLOAD = {
    page: {
      type: 'LIST',
      entity: 'TicketView',
      windowId: windowId
    },
    data: {
      viewId: viewId,
      condition: context?.viewConditions || null,
      allowSimultaneousPage: false
    }
  };

  const [liveUpdateCondition, setLiveUpdateCondition] = useState(
    context?.viewConditions || null
  );
  const [websocketPayLoad, setWebSocketPayLoad] = useState(DEFAULT_WS_PAYLOAD);

  useEffect(() => {
    if (isEmpty(context?.viewConditions) && isEmpty(liveUpdateCondition)) {
      return;
    }
    const isUpdated = !isEqual(liveUpdateCondition, context?.viewConditions);
    if (isUpdated) {
      const updatedPayLoad = cloneDeep(websocketPayLoad);
      updatedPayLoad.data.condition = context?.viewConditions;
      setWebSocketPayLoad(updatedPayLoad);
      setLiveUpdateCondition(context?.viewConditions);
    }
  }, [context?.viewConditions]);

  if (personalizationLoading || !columnGroup[0]?.columns?.length) {
    <SkeletonTableLoading />;
  }

  return (
    <div className="fhp super-table-container">
      <SuperTable
        context={{
          ...context,
          viewConditions: tableConditionsForFilter
        }}
        columns={columnGroupByRef.current}
        data={dataByRef.current}
        refreshTable={fetchViewData}
        listInfo={
          listInfoByRef.current
            ? {
                ...listInfoByRef.current,
                sort: listInfoByRef.current?.sort || sortFromGlobalState
              }
            : {}
        }
        isLoading={ticketListLoading || isLiveUpdating}
        tableName={tableName}
        user={user}
        dynamicRowCount={!!dynamicPaginationFlag}
        rowCount={rowCount}
        setRowCount={setRowCount}
        saveTableRowCount={saveTableRowCount}
        columnWidthPersonalization
        saveColumnWidth={saveColumnWidth}
        defaultColumnCells={defaultColumn}
        noBulkSelect={!isTicketEditAuthorised}
        checkBoxDisabledCheck={isCheckBoxInactive}
        editCellId={editCellId}
        enableLiveUpdate={
          isMSP && flags?.ticketListviewPageRefresh && !props?.disableLiveUpdate
        } // flag to enable live update
        wsPayload={websocketPayLoad} // Payload to send for websocket
        liveUpdateCondition={liveUpdateCondition}
        // Whenever this prop changes we'll call update WS with updated conditions
        onMessage={onWebSocketEventMessage}
        // function when we recieve websocket event
        // Based on the data we'll set showLiveUpdate state
        showLiveUpdate={showLiveUpdate} // To show refresh button
        onLiveUpdateRefresh={onLiveUpdateRefresh}
        // Action to do when refresh button is clicked
        // This is Optional this will be taken care by the table itself if not passed
        isLiveUpdateInProgress={isLiveUpdating} // To make refresh button in loading state
        checkRowHighlight={checkRowHighlight} // To check if row is highlighted
        refreshButtonStyles={{
          '.refresh-notification': {
            // Target the class directly
            left: '40% !important'
          }
        }}
        emptyState={{
          // nodataImage: `${envConfig.imageRoot}svg/TicketEmptyState.svg)`,
          nodataImage: `${envConfig.imageRoot}svg/TicketEmptyState.svg`,
          heading: getTranslatedText(intl, 'alert.noTicketsFound.heading'),
          description: getTranslatedText(intl, 'alert.noTicketsFound.desc')
        }}
        registerPageDelay={100}
      />

      {errorsOnClosureByRef.current && (
        <>
          <ClosureModal
            modalActive={closureModalactive}
            setModalActive={setClosureModalActive}
            errorsOnClosure={errorsOnClosureByRef.current}
            setErrorsOnClosure={setErrorsOnClosure}
            onSave={updateTicketOnClosure}
            saveLoading={closureSaveLoading}
            onClose={() => setClosureModalActive(false)}
          />
        </>
      )}
    </div>
  );
}

export default React.memo(injectIntl(withRouter(TicketContainer)));
